export const styles = {
  container: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    pl: 3,
    pr: 2,
    [theme.breakpoints.up('sm')]: {
      pl: 4,
      pr: 3,
    },
  }),
  appBar: (theme) => ({
    backgroundColor: theme.palette.accentFade.main,
  }),

  line: (theme) => ({
    backgroundColor: theme.palette.primary.main,
    borderRadius: 1,
    mx: 1,
    [theme.breakpoints.up('sm')]: {
      mx: 2,
    },
    height: 24,
    width: '1px',
  }),
};
